import React from 'react'
import { Avatar, Dropdown } from 'rsuite'
import { useAuthContext } from '../../../auth/AuthContext'
import ExitIcon from '@rsuite/icons/Exit'
import { useNavigate } from 'react-router-dom'
import { useAppDispatch, useAppSelector } from '../../../app/hooks'
import { navigatePage } from '../../../misc/utils/navigation'
import { userSelector } from '../../../features/user/userSlice'
import { callerGroupFromRoles } from '../../../misc/utils/callerGroup'

const logoStyle: React.CSSProperties = {
  paddingLeft: '65px',
  paddingRight: '65px',
  paddingTop: '20px',
  paddingBottom: '20px',
  height: 120,
  // No global border-box reset in this app: without it the 40px vertical padding grows this
  // block to 160px and pushes the avatar/logout footer below the 100vh overflow-hidden wrapper.
  boxSizing: 'border-box'
}

export interface OnlineUsersProps {
  interpreters: number
  pending: number
}

const StatBox = ({ label, count, img }) => {
  return (
    <div style={{ backgroundColor: '#EEF2F3', margin: 20, padding: 10, borderRadius: 20 }}>
      <p style={{ textAlign: 'center', fontFamily: 'Alegreya Sans', fontSize: 25, color: '#575757' }}>{label}</p>
      <p style={{ textAlign: 'center', fontFamily: 'Alegreya Sans', fontSize: 55, color: '#3C888C' }}>{count}</p>
      <p style={{ textAlign: 'center' }}><img src={img} alt={label}/></p>
    </div>
  )
}

const Stats: React.FC<OnlineUsersProps> = ({ interpreters, pending }) => {
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const { user } = useAppSelector(userSelector)

  const auth = useAuthContext()

  return (
    // Flex column instead of hand-computed calc() heights: the stats area takes the leftover
    // space and scrolls, so the avatar/logout footer always stays inside the viewport.
    // paddingBottom clears the fixed 25px privacy/terms bar at the page bottom.
    <div style={{ height: '100vh', display: 'flex', flexDirection: 'column', boxSizing: 'border-box', paddingBottom: 30 }}>
      <div style={logoStyle}>
        <img width={'100%'} src="/img/logo.svg" alt="Iris"/>
      </div>

      <div style={{ flex: 1, minHeight: 0, overflowY: 'auto' }}>
        <StatBox label="διερμηνείς" count={interpreters} img="/img/home/interpreter.svg"/>
        <StatBox label="χρήστες σε αναμονή" count={pending} img="/img/home/deaf.svg"/>
        {/*<p style={{ textAlign: 'center', margin: 20, padding: 10, borderRadius: 20, backgroundColor: '#F6F4F4' }}>*/}
        {/*  <img style={{ width: 100 }} src="/img/home/eik.png" alt="Ίδρυμα κοφών" />*/}
        {/*</p>*/}
      </div>
      <div style={{ height: 1, backgroundColor: '#ECF0F1' }}/>
      {callerGroupFromRoles(user?.token?.roles) === 'VODAFONE_SHOP' ? (
        // Vodafone Shops account chip (approved private-label design): roundel + store identity,
        // with profile/logout tucked into the menu.
        <Dropdown placement="topStart" style={{ width: '100%' }} renderToggle={(props, ref) => (
          <div {...props} ref={ref}
               style={{ display: 'flex', alignItems: 'center', gap: 10, padding: '12px 14px', cursor: 'pointer' }}>
            <img src="/img/vodafone/roundel.png" alt="" style={{ width: 36, height: 36, flex: 'none' }}/>
            <span>
              <b style={{ display: 'block', fontSize: 14.5, color: '#2e3638' }}>
                {user?.token?.first_name ?? 'Vodafone Store'}
              </b>
              <span style={{ fontSize: 12, color: '#8a9698' }}>Vodafone User</span>
            </span>
            <span style={{ marginLeft: 'auto', color: '#8a9698', fontSize: 13 }}>▾</span>
          </div>
        )}>
          <Dropdown.Item onSelect={() => navigatePage(dispatch, navigate, '/user')}>Το προφίλ μου</Dropdown.Item>
          <Dropdown.Item onSelect={() => auth.logout()}>Αποσύνδεση</Dropdown.Item>
        </Dropdown>
      ) : (
        <div style={{ color: '#575757', position: 'relative', paddingTop: 16 }}>
          <span style={{ cursor: 'pointer' }} onClick={() => navigatePage(dispatch, navigate, '/user')}>
            <Avatar circle src={user?.info.person.image ?? '/img/avatar.svg'}
                    style={{ border: '1px solid white', marginLeft: 10 }}/>
            <span style={{ position: 'absolute', left: 60, top: 26, fontSize: 16 }}>εσείς</span>
          </span>
          <span onClick={() => auth.logout()}
                style={{ position: 'absolute', right: 20, top: 26, fontSize: 18, cursor: 'pointer' }}>
            <ExitIcon/>
          </span>
        </div>
      )}
    </div>
  )
}

export default Stats
